module.exports = __webpack_public_path__ + "img/tongguo.69af78e9.png";